import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { bumexFeaturesKeys } from '@panel/core/src/constants/bumexFeatures';
import Notifications from '@navent-re/notifications';
import { useTranslation } from 'react-i18next';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import styled from 'styled-components';
import { ModalContext } from './modal/src';

const NotificationsContainer = styled.div`
  line-height: normal;
  div[class*='tooltipContent'] {
    width: auto !important;
  }
`;

const NotificationButton = ({ isLogged, isMobile }) => {
  const { t } = useTranslation();
  const { openModal, handleModal } = useContext(ModalContext);
  const siteId = process.env.REACT_APP_BUILD_SITE;

  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const enableCountryCodeInput = bumexFeatures.get(bumexFeaturesKeys.ENABLE_COUNTRY_CODE_INPUT);

  const notificationTranslations = {
    notificationDefaultView: {
      title: t('panel.notifications.notificationDefaultView.title')
    },
    tooltipTitleNew: t('panel.notifications.tooltipTitleNew.title'),
    modalTitle: t('panel.notifications.modalTitle')
  };

  const reconfirmationTranslations = {
    modalTitle: t('panel.reconfirmation.modal.title'),
    inputLabel: t('panel.reconfirmation.input.label'),
    inputPlaceholder: t('panel.reconfirmation.input.placeholder'),
    editButton: t('panel.reconfirmation.edit.button'),
    confirmButton: t('panel.reconfirmation.confirm.button'),
    saveButton: t('panel.reconfirmation.save.button'),
    errorMessage: t('panel.reconfirmation.error.message'),
    validMessage: t('panel.reconfirmation.valid.message'),
    sendButton: t('panel.reconfirmation.send.button'),
    selfButton: t('panel.reconfirmation.self.button'),
    whatsappButton: t('panel.reconfirmation.whatsapp.button'),
    emailButton: t('panel.reconfirmation.email.button'),
    telButton: t('panel.reconfirmation.tel.button'),
    selectTitle: t('panel.reconfirmation.select.title'),
    successMessage: t('panel.reconfirmation.success.message'),
    closeButton: t('panel.reconfirmation.close.button'),
    errorTitle: t('panel.reconfirmation.error.title'),
    errorSubTitle: t('panel.reconfirmation.error.subtitle'),
    errorCTA: t('panel.reconfirmation.error.CTA'),
    searchPlaceholder: t('panel.reconfirmation.countryPhoneCode.searchPlaceholder'),
    modalCountryListTitle: t('panel.reconfirmation.countryPhoneCode.modalCountryListTitle'),
    buttonLabel: t('panel.reconfirmation.countryPhoneCode.buttonLabel'),
    phoneLabel: t('panel.reconfirmation.countryPhoneCode.phoneLabel'),
    phoneError: t('panel.reconfirmation.countryPhoneCode.phoneError')
  };

  return (
    <NotificationsContainer>
      <Notifications
        modalTitle={notificationTranslations.modalTitle}
        showTooltip={false}
        isLogged={isLogged}
        translations={notificationTranslations}
        onClickOpenModal={openModal}
        handleModal={handleModal}
        reconfirmTranslations={reconfirmationTranslations}
        isMobile={isMobile}
        siteId={siteId}
        enableCountryCodeInput={enableCountryCodeInput}
      />
    </NotificationsContainer>
  );
};

export default NotificationButton;
